import React, { useState, useEffect } from 'react';
import axios from '../../api/axiosConfig'; // Use configured axios for internal access
import PrintablePriceList from '../printable/PrintablePriceList'; // Correct path
import LoadingSpinner from '../../components/common/LoadingSpinner';

// Define the expected structure of the fetched price list data
// (Should match the structure returned by getPriceListDataForPrint)
interface PriceListData {
  structures: Array<{
    id: number;
    code: string;
    type: string;
    location: string;
    dimensions?: string | null;
    isLED: boolean;
    dailyPrice: number;
    monthlyPrice: number;
  }>;
  validUntil: Date | string;
}

const PriceListPrintPage: React.FC = () => {
  const [priceListData, setPriceListData] = useState<PriceListData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPriceListData = async () => {
      setLoading(true);
      setError(null);
      try {
        // Use the new backend endpoint for price list print data
        const response = await axios.get<PriceListData>(`/reports/price-list/print-data`);
        setPriceListData(response.data);
        // Attempt to trigger print dialog after data is loaded
        setTimeout(() => {
          // window.print();
        }, 500); // Small delay
      } catch (err: any) {
        console.error('Error fetching price list data for printing:', err);
        setError(err.response?.data?.message || 'Не удалось загрузить данные прайс-листа для печати.');
      } finally {
        setLoading(false);
      }
    };

    fetchPriceListData();
  }, []); // Fetch only once on mount

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <div className="printable-container error-message">Ошибка: {error}</div>;
  }

  if (!priceListData) {
    return <div className="printable-container">Данные прайс-листа для печати не найдены.</div>;
  }

  // Render the printable component with the fetched data
  return <PrintablePriceList priceListData={priceListData} />;
};

export default PriceListPrintPage;
